import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/nicola/workspace/react-csv-reader/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "react-csv-reader"
    }}>{`react-csv-reader`}</h1>
    <p><a parentName="p" {...{
        "href": "https://www.npmjs.com/package/react-csv-reader"
      }}><img alt="npm version" src="https://img.shields.io/github/package-json/v/nzambello/react-csv-reader" /></a>{`
`}<a parentName="p" {...{
        "href": "https://www.npmjs.com/package/react-csv-reader"
      }}><img alt="npm" src="https://img.shields.io/npm/dt/react-csv-reader" /></a>{`
`}<img alt="Node.js CI" src="https://github.com/nzambello/react-csv-reader/workflows/Node.js%20CI/badge.svg?branch=master" />{`
`}<img alt="a11y axe" src="https://img.shields.io/badge/a11y-tested-brightgreen" />{`
`}<img alt="TypeScript Support" src="https://img.shields.io/badge/TypeScript-Support-blue" /></p>
    <p>{`React component that handles csv file input.`}<br parentName="p"></br>{`
`}{`It handles file input and returns its content as a matrix.`}</p>
    <p>{`You can try it out in the `}<a parentName="p" {...{
        "href": "/react-csv-reader/usage#playground"
      }}>{`playground`}</a>{` or in the `}<a parentName="p" {...{
        "href": "https://codesandbox.io/s/react-csv-reader-vtull"
      }}>{`demo on Codesandbox`}</a>{`.`}</p>
    <h2 {...{
      "id": "installation"
    }}>{`Installation`}</h2>
    <p>{`Install the package with either yarn or npm.`}</p>
    <p>{`With yarn:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`yarn add react-csv-reader
`}</code></pre>
    <p>{`With npm:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`npm install --save react-csv-reader
`}</code></pre>
    <h2 {...{
      "id": "typescript-support"
    }}>{`TypeScript support`}</h2>
    <p>{`For type definitions, see `}<a parentName="p" {...{
        "href": "https://github.com/nzambello/react-csv-reader/blob/master/src/index.tsx#L5"
      }}>{`here`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      